import {
  ApiBlueprint,
  configApiRef,
  createApiRef,
  createFrontendModule,
  discoveryApiRef,
  oauthRequestApiRef,
} from '@backstage/frontend-plugin-api';
import type {
  BackstageIdentityApi,
  OpenIdConnectApi,
  ProfileInfoApi,
  SessionApi,
} from '@backstage/core-plugin-api';
import { OAuth2 } from '@backstage/core-app-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';

export const studioAuthApiRef = createApiRef<
  OpenIdConnectApi & ProfileInfoApi & BackstageIdentityApi & SessionApi
>().with({ id: 'auth.studio' });

const studioAuthApi = ApiBlueprint.make({
  name: 'studio',
  params: defineParams =>
    defineParams({
      api: studioAuthApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        oauthRequestApi: oauthRequestApiRef,
        configApi: configApiRef,
      },
      factory: ({ discoveryApi, oauthRequestApi, configApi }) =>
        OAuth2.create({
          configApi,
          discoveryApi,
          oauthRequestApi,
          environment: configApi.getOptionalString('auth.environment'),
          provider: {
            id: 'studio',
            title: 'Tech Fernandes Studio',
            icon: () => null,
          },
          defaultScopes: [],
        }),
    }),
});

export const studioSignInModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    studioAuthApi,
    SignInPageBlueprint.make({
      params: {
        loader: async () => props => (
          <SignInPage
            {...props}
            provider={{
              id: 'studio',
              title: 'Entrar com Tech Fernandes Studio',
              message: 'Use sua sessão do Studio para acessar a operação.',
              apiRef: studioAuthApiRef,
            }}
          />
        ),
      },
    }),
  ],
});
